import { isUndefined } from 'lodash';

import { PlacementErrorsIds, TPlacementErrorIdType, VALIDATION_ERROR_BET_MAX_PROFIT } from 'constants/placement';
import { TSuccessFetchCurrency } from 'redux/modules/appConfigs/type';
import { TProfit } from 'types/bets';
import { precisionFormat } from 'utils/size';

export const getMaxProfit = ({
  currency,
  defaultCurrency,
  isGame
}: {
  currency?: TSuccessFetchCurrency;
  defaultCurrency?: TSuccessFetchCurrency;
  isGame?: boolean;
}) => {
  const maxField: keyof TSuccessFetchCurrency = isGame ? 'gamesMaxProfit' : 'maxProfit';

  return currency?.[maxField] || defaultCurrency?.[maxField] || 0;
};

export const getIsMaxProfitValid = ({
  profit,
  currency,
  defaultCurrency,
  isGame
}: {
  profit: TProfit;
  currency?: TSuccessFetchCurrency;
  defaultCurrency?: TSuccessFetchCurrency;
  isGame?: boolean;
}) => {
  const maxProfit = getMaxProfit({ currency, defaultCurrency, isGame });

  return !maxProfit || Number(profit) <= maxProfit;
};

export const validateProfit = ({
  profit,
  currency,
  defaultCurrency,
  isOperatorBettingLimitsEnabled = false,
  isGame = false
}: {
  profit: TProfit;
  currency: TSuccessFetchCurrency;
  defaultCurrency: TSuccessFetchCurrency;
  isOperatorBettingLimitsEnabled?: boolean;
  isGame?: boolean;
}): {
  validValue?: string | number | null;
  errorMessage: { text: string; params: Record<string, number | string | undefined> } | null;
  isValid: boolean;
  type: 'max' | null;
  messageId: null | TPlacementErrorIdType;
} => {
  const maxProfit = getMaxProfit({ currency, defaultCurrency, isGame });
  const value: TProfit = profit ? parseFloat(profit as string) : profit;
  const isEmptyValue = profit === '' || isUndefined(profit);
  const isMaxProfitValid = getIsMaxProfitValid({ profit: value, currency, defaultCurrency, isGame });

  if (isEmptyValue) {
    return { validValue: '', errorMessage: null, isValid: false, type: null, messageId: null };
  }

  if (!isMaxProfitValid) {
    if (!isOperatorBettingLimitsEnabled) {
      return {
        validValue: maxProfit,
        errorMessage: {
          text: VALIDATION_ERROR_BET_MAX_PROFIT,
          params: { max_profit: precisionFormat(maxProfit) }
        },
        isValid: false,
        type: 'max',
        messageId: PlacementErrorsIds.BET_MAX_PROFIT
      };
    }
  }

  return {
    validValue: value,
    errorMessage: null,
    isValid: true,
    type: null,
    messageId: null
  };
};
